import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: { fontWeight: "bold", margin: 0, padding: 0 },
}));

const LabelStatusButton = (props) => {
  const classes = useStyles();

  if (props.code === "P") {
    return (
      <Button
        className={classes.root}
        style={{
          color: "#0B6838",
          backgroundColor: "#CDFFE4",
          cursor: "default",
        }}
      >
        {props.desc}
      </Button>
    );
  } else if (props.code === "N") {
    return (
        <Button
          className={classes.root}
          style={{
            color: "#AC7E07",
            backgroundColor: "#FFC6C6",
            cursor: "default",
          }}
        >
          {props.desc}
        </Button>
      );
  } else {
    return (
        <Button
          className={classes.root}
          style={{
            cursor: "default",
          }}
        >
          {props.resultCodeDesc}
        </Button>
      );
  }

};

export default LabelStatusButton;
